'use client'
// 立即訂閱

import { useDispatch } from "react-redux";
import { useState } from "react";
import CRSubscribeInput from "./CRSubscribeInput";
import { setCRShowEmailPop, setCREmail } from "@/slices/cryptoReadSlice";
import { sendEmail } from "../common/functions";

const CRSubscribe = () => {
    const [email, setEmail] = useState(null);
    const [submitError, setSubmitError] = useState(false);
    const dispatch = useDispatch();

    const onChangeEmail = (info) =>{
        setEmail(info)
    }

    const onChangeSubmitError = (info) =>{
        setSubmitError(info)
    }
    
    // 送出email
    const submitEmail = async () =>{
        await sendEmail(
            email,
            onChangeEmail,
            onChangeSubmitError,
            dispatch,
            setCREmail,
            setCRShowEmailPop,
        )
    }

    return(
        <section id='cr-subscribe' className="cr-section cr-subscribe w-full 
            flex flex-col center-center
            asm:h-[calc(100vh-144px)]  
            umd:pt-[107px] usm:px-[16px] usm:pointer-events-auto
        ">
            <CRSubscribeInput
                email={email}
                submitError={submitError}
                onChangeEmail={onChangeEmail}
                onChangeSubmitError={onChangeSubmitError}
                sendEmail={submitEmail}
            />
        </section>
    )
}

export default CRSubscribe;